// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchByInitial_root__HO-P0","title":"SearchByInitial_title__2XjBG","initials":"SearchByInitial_initials__21_mM","initial":"SearchByInitial_initial__1b6gm"};